// import { getHotelTypes, getHotelAmenities, getHotelThemes, getRoomAmenities } from 'b2b-common/services/api/hotel'
import { getSearchParams, getSearchResults, search } from 'b2b-common/services/api/package'
import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByHotDeal,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    packageType: '',
    rooms: [{ adults: 2, childAges: [] }],
    product_type: null,
    done: false
  },
  results: [],
  hasTransport: true,

  async init ({ packageType = 'package' } = {}) {
    if (this.initDataLoaded) return true
    const params = getSearchParams({ packageType, dc: this.distribution, product: this.params.product_type })
    const results = getSearchResults({ packageType, dc: this.distribution, product: this.params.product_type })
    this.params = await params
    const res = await results
    this.results = res.results
    this.hasTransport = res.has_transport
    this.sort({ sortMethod: this.sortMethod })
    this.initDataLoaded = true
    return true
  },

  sort ({ sortMethod = sortByHotDeal }) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ packageType: params.packageType, dc: this.distribution, product: params.product_type })
    this.params = newParams
    this.results = res.results
    this.hasTransport = res.has_transport
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
